import React from "react";
import ButtonInside from "../atoms/ButtonInside";
import "./Filters.css";
import Grid from "@mui/material/Grid";
import DropDown from "../atoms/DropDown";
const genres = ["All Genre", "Education", "Sports", "Comedy", "Lifestyle"];
const ageFilter = ["Any age group", "7+", "12+", "16+", "18+"];
export default function Filters(props) {
  const {
    genreFilters,
    ageFilters,
    sortBy,
    genreFiltersApplied,
    ageFiltersApplied,
    checkSortBy,
    isSearched,
  } = props;

  const handleGenreClick = (btnText, isActive) => {
    if (btnText != "All Genre" && isActive === true) {
      genreFiltersApplied({
        ...genreFilters,
        [btnText]: isActive,
        "All Genre": false,
      });
    } else if (btnText === "All Genre" && isActive === true) {
      genreFiltersApplied({
        "All Genre": true,
        Education: false,
        Sports: false,
        Comedy: false,
        Lifestyle: false,
      });
    } else {
      genreFiltersApplied({
        ...genreFilters,
        [btnText]: isActive,
      });
    }
  };
  const handleAgeClick = (btnText, isActive) => {
    ageFiltersApplied({
      "Any age group": false,
      "7+": false,
      "12+": false,
      "16+": false,
      "18+": false,
      [btnText]: isActive,
    });
  };

  const sortByFn = (sortBy) => {
    checkSortBy(sortBy);
  };

  return (
    <>
      {isSearched === "" && (
        <div className="filters">
          <div style={{ display: "flex" }}>
            <Grid container spacing={1} className="genresDiv">
              {genres.map((item, idx) => {
                return (
                  <Grid
                    key={item}
                    item
                    className={genreFilters[item] ? "selectedGenres" : "genres"}
                  >
                    <ButtonInside
                      className=".genre-btn"
                      flag={genreFilters[item]}
                      key={item}
                      btnText={item}
                      btnHandler={handleGenreClick}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <DropDown sortByFn={sortByFn} />
          </div>
          <Grid container spacing={1} className="genresDiv">
            {ageFilter.map((item, idx) => {
              return (
                <Grid
                  key={item}
                  item
                  className={ageFilters[item] ? "selectedGenres" : "genres"}
                >
                  <ButtonInside
                  className="content-rating-btn"
                    flag={ageFilters[item]}
                    key={item}
                    btnText={item}
                    btnHandler={handleAgeClick}
                  />
                </Grid>
              );
            })}
          </Grid>
        </div>
      )}
    </>
  );
}
